import React from 'react';

import { getMoment, showTime, showPeriod, showPeriodByDay, showDateNoTime } from '@libs/NwMoment';

export const showEventTime = (sd, ed, sb, eb) => {
    const st = getMoment(sd);
    const et = getMoment(ed);
    const sbt = sb ? getMoment(sb) : null;
    const ebt = eb ? getMoment(eb) : null;

    if (sbt && ebt) {
        return (
            <>
                <span>
                    {showTime(st)} - {showTime(sbt)}
                </span>
                <span>
                    {showTime(ebt)} - {showTime(et)}
                </span>
            </>
        );
    }
    if (
        st.hours() === 0 &&
        st.minutes() === 0 &&
        ((et.hours() === 23 && et.minutes() === 59) || (et.hours() === 0 && et.minutes() === 0))
    ) {
        if (et.isAfter(st, 'day')) {
            return showPeriodByDay(st, et);
        }
        return 'ALL DAY';
    } else {
        if (et.isAfter(st, 'day')) {
            return showPeriod(st, et);
        }
        if (st.hours() === et.hours() && st.minutes() === et.minutes()) {
            return `${showTime(sd)}`;
        } else {
            return `${showTime(sd)} - ${showTime(ed)}`;
        }
    }
};

export const isLongEvent = (startDate, endDate) => {
    return endDate && showDateNoTime(startDate) !== showDateNoTime(endDate);
};
